import React from 'react';

import { appMethod as app } from '@utils/app';
import { transformPx2Rem } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import './TimelineCustomComponent.less';

/**
 * type: 'timeline',
 * 组件：秒杀时间轴组件
 */
export default class TimelineCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let that = this;
    let timelineData = pageInstance.data.eles[compindex];
    let timelineCustomFeature = timelineData.customFeature;
    let seckillCompindex = app.findComponentIndexById(timelineCustomFeature.timeline_object, pageInstance);

    //获取时间轴对应的秒杀活动id
    if (seckillCompindex > -1) {
      let seckillCustomFeature = pageInstance.data.eles[seckillCompindex].customFeature;
      if (seckillCustomFeature.seckillType === 'activeSeckill' && seckillCustomFeature.isShowFranchiseeGoods) { // 多店活动秒杀
        let activityId = seckillCustomFeature.seckillActive;
        let result = pageInstance.callComponentMethod({
          componentIndex: seckillCompindex,
          methodName: 'checkActivityIsFranchisee',
          argvs: [activityId]
        })
        result && result.then((flag) => {
          that.timelineInit(compindex, pageInstance, flag, timelineData, activityId);
        }).catch(err => {
          console.log(err);
        });
      }else {
        this.timelineInit(compindex, pageInstance);
      }
    }
  }  

  /** 秒杀时间轴组件初始化*/
  timelineInit = (compindex, pageInstance, isFranchisee, tlData, activityId) => {
    let that =this;
    let timelineData = tlData || pageInstance.data.eles[compindex];
    timelineData.compindex = this.props.index;
    timelineData.customFeature.selectNum = -1;
    for (let i = 0; i < timelineData.content.length;i++){
      if (timelineData.content[i].isShowTheArea && timelineData.customFeature.selectNum == -1){
        timelineData.customFeature.selectNum = i;//默认选中第一个开启显示的
      }
    }
    timelineData.customFeature.compindex = app.findComponentIndexById(timelineData.customFeature.timeline_object, pageInstance);
    //获取时间轴对应的秒杀活动id
    if (timelineData.customFeature.compindex > -1){
      timelineData.activeId = activityId || pageInstance.data.eles[timelineData.customFeature.compindex].customFeature.seckillActive;
    }
    let newData = {};
    if (timelineData.customFeature.mode == 1 || timelineData.customFeature.mode == 2) {
      newData['eles[' + compindex + '].customFeature.selectNum'] = timelineData.customFeature.selectNum;
      newData['eles[' + compindex + '].customFeature.isFranchisee'] = !!isFranchisee;
      let param={
        currentTarget:{
          dataset:{
            compindex: timelineData.compindex,
            index: timelineData.customFeature.selectNum,
            isFranchisee: !!isFranchisee,
          }
        }
      }
      that.screeningSeckillList(param)
      pageInstance.setData(newData);
    } else {
      app.sendRequest({
        url: '/index.php?r=AppMarketing/GetSeckillActivityTime',
        data: {
          activity_id: timelineData.activeId
        },
        success: function (res) {
          if(!res.status){
            //删除明天以后的秒杀数据，并添加一个更多预告
            let data = res.data;
            let num = 0;
            let deleteIndex=0;
            let selectNum = -1;
            for(let i=0;i<data.length;i++){
              if (data[i].date_diff >1 && num==0){
                deleteIndex=i;
              }
              if (data[i].date_diff > 1){
                num=num+1;
              }
              if (data[i].start_timestamp < res.time){
                data[i].isShowTheArea = timelineData.content[0].isShowTheArea
              }
              if (data[i].date_diff == 0 && data[i].start_timestamp > res.time){
                data[i].isShowTheArea = timelineData.content[1].isShowTheArea
              }
              if (data[i].date_diff == 1){
                data[i].isShowTheArea = timelineData.content[2].isShowTheArea
              }
              if (data[i].isShowTheArea && selectNum == -1){
                selectNum = i
              }
            }
            if (num){
              data.splice(deleteIndex, num);
              data.push({'date_diff':'more', 'isShowTheArea': timelineData.content[3].isShowTheArea})
            }
            newData['eles[' + compindex + '].timelineData'] = data;
            newData['eles[' + compindex + '].severTime'] = res.time;
            newData['eles[' + compindex + '].customFeature.selectNum'] = selectNum;
            newData['eles[' + compindex + '].customFeature.isFranchisee'] = !!isFranchisee;
          }
          pageInstance.setData(newData);
          let param = {
            currentTarget: {
              dataset: {
                compindex: timelineData.compindex,
                index: newData['eles[' + compindex + '].customFeature.selectNum'],
                isFranchisee: !!isFranchisee,
              }
            }
          }
          that.screeningSeckillList(param)
        }
      })
    }
  }

   /**
    * 点击时间轴筛选秒杀列表
    */
  screeningSeckillList = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let timelineParameter = e.currentTarget.dataset;
    let timelineData = pageInstance.data.eles[timelineParameter.compindex];
    let compindex = timelineData.customFeature.compindex;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let param = {};

    let newdata = {};
    let seckill_activity_time_id='';
    let seckill_activity_time_type ='';
    newdata['eles[' + timelineParameter.compindex + '].customFeature.selectNum'] = timelineParameter.index;

    if (timelineData.customFeature.mode == 1 || timelineData.customFeature.mode == 2) {
      if (timelineParameter.index<2){
        seckill_activity_time_type = timelineParameter.index+1;
      }else{
        seckill_activity_time_type = timelineParameter.index+2;
      }
    }else{
      if (timelineData.timelineData[timelineParameter.index]&&timelineData.timelineData[timelineParameter.index].date_diff != 'more'){
        seckill_activity_time_id = timelineData.timelineData[timelineParameter.index].id
      }else{
        seckill_activity_time_type=5;
      }
    }
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex]){
      let downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (let i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].goods_data'] = [];

    param.form =  "goods";
    param.goods_type = 0;
    param.page_size = customFeature.loadingNum || 10;
    param.is_seckill = 1;
    param.page = 1;
    param.is_integral = customFeature.isIntegral ? 1 : 0;
    param.is_count = 0;
    param.seckill_activity_arr = {
      seckill_activity_id: timelineData.activeId,
      seckill_activity_time_id: seckill_activity_time_id,
      seckill_activity_time_type: seckill_activity_time_type
    };
    param.is_seckill_activity = 1;
    if (timelineParameter['isFranchisee']) {
      param['is_app_shop_seckill'] = 1;
    }

    newdata['eles[' + compindex + '].seckill_activity_arr'] = param.seckill_activity_arr;
    newdata['eles[' + compindex + '].param'] = param;

    pageInstance.setData(newdata);

    app.sendRequest({
      hideLoading: true,   // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      success: function (res) {
        let rdata = res.data,
          appId = app.getAppId(),
          newdata = {},
          downcountArr = pageInstance.downcountObject[compindex] || [];
        if (rdata){
          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i].form_data,
              dc;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (f.seckill_start_state == 0) {
              dc = app.beforeSeckillDownCount(f, pageInstance, compindex + '.goods_data[' + i + '].form_data');
            } else if (f.seckill_start_state == 1) {
              dc = app.duringSeckillDownCount(f, pageInstance, compindex + '.goods_data[' + i + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              rdata[i].form_data = pageInstance.callComponentMethod({
                componentIndex: compindex,
                methodName: 'seckillStartTimeView',
                argvs: [f]
              })
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
        }
        newdata['eles[' + compindex + '].goods_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.downcountObject[compindex] = downcountArr;
        pageInstance.setData(newdata);

      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  render() {
    /**
     * @desc 时间轴组件数据
     */
    const data = this.props.data;
    let {
      customFeature, content, timelineData,
      severTime
    } = this.props.data;
    if (!timelineData) { timelineData = []; }
    let {
      background, fontSize, fontColor,
      fontWeight, fontStyle, textDecoration,
      maskMarginSpace, isFranchisee, mode,
      selectNum,
      underlineHeight, underlineColor, selectFontBackground,
      fontRadius, singleBackground,
    } = customFeature;

    maskMarginSpace = transformPx2Rem(maskMarginSpace);

    /**
     * @desc 样式转换
     */
    const styleObj = {
      height: this.props.data.style.height
    }

    /**
     * @desc 时间轴样式处理
     */
    const timelineStyleObj = {
      fontSize: transformPx2Rem(fontSize, 320),
      color: fontColor,
      fontWeight,
      fontStyle,
      textDecoration
    };

    /**
     * @desc 选中样式处理
     */
    const selectStyleObj = {
      fontSize: customFeature.selectFontSize,
      color: customFeature.selectFontColor,
      fontWeight: customFeature.selectFontWeight,
      fontStyle: customFeature.selectFontStyle,
      textDecoration: customFeature.selectTextDecoration
    };

    const selectTimeStyleObj = {
      fontSize: customFeature.selectTimeFontSize,
      color: customFeature.selectTimeFontColor,
      fontWeight: customFeature.selectTimeFontWeight,
      fontStyle: customFeature.selectTimeFontStyle,
      textDecoration: customFeature.selectTimeTextDecoration
    }
    return (
      <div className="custom-component timeline" style={{ background }}>
        <ScrollView scroll-x={true} style={{background: data.customFeature.background}}>
          <div style={{ ...styleObj, ...timelineStyleObj }} className="time-line">
            {
              content.map((item, index) => (
                <React.Fragment key={index}>
                  {
                    mode == 1 && item.isShowTheArea &&
                    <div className="first-time-line"
                      style={{ marginRight: maskMarginSpace }}
                      data-index={index}
                      data-compindex={this.props.index}
                      data-is-franchisee={isFranchisee || false}
                      onClick={this.screeningSeckillList}>
                      <div className='first-timeline-font timeline-padLTB'
                          style={selectNum == index ? selectStyleObj : {}}>{item.name}</div>
                      {
                        selectNum == index &&
                        <div className="select-line" style={{ height: underlineHeight, background: underlineColor }}></div>
                      }
                    </div>
                  }
                  {
                    mode == 2 && item.isShowTheArea &&
                    <div className="first-time-line"
                        style={{ marginRight: maskMarginSpace }}
                        data-index={index}
                        data-compindex={this.props.index}
                        data-is-franchisee={isFranchisee || false}
                        onClick={this.screeningSeckillList}>
                      <div className='first-timeline-font'
                          style={selectNum == index ? { background: selectFontBackground, borderRadius: fontRadius, ...selectStyleObj } : {}}>{item.name}</div>
                    </div>
                  }
                </React.Fragment>
              ))
            }
            {(mode != 2 && mode != 1) && timelineData.map((item, index) => {
              return item.isShowTheArea && <React.Fragment key={index}>
                <div className="first-time-line"
                  style={{ marginRight: maskMarginSpace, background: mode == 5 && (selectNum == index ? singleBackground : '') }}
                  data-index={index}
                  data-compindex={this.props.index}
                  data-is-franchisee={isFranchisee || false}
                  onClick={this.screeningSeckillList}>
                  <div>
                    {item.date_diff != 'more' &&
                      <div className='timeline-time' style={selectNum == index ? selectTimeStyleObj : {}}>
                        {(mode == 3 || mode == 5) && <span>{item.start_time}</span>}
                        {mode == 4 &&
                          <span style={selectNum == index ? { background: selectFontBackground, borderRadius: fontRadius } : {}}>{item.start_time}</span>
                        }
                      </div>
                    }
                    <div className='first-timeline-font timeline-padLTB'
                      style={selectNum == index ? selectStyleObj : {}}>
                      {item.start_timestamp <= severTime && content[0].isShowTheArea && <React.Fragment>{content[0].name}</React.Fragment>}
                      {item.date_diff == 0 && (item.start_timestamp > severTime) && content[1].isShowTheArea && <React.Fragment>{content[1].name}</React.Fragment>}
                      {item.date_diff == 1 && content[2].isShowTheArea && <React.Fragment>{content[2].name}</React.Fragment>}
                      {item.date_diff == 'more' && content[3].isShowTheArea && <React.Fragment>{content[3].name}</React.Fragment>}
                    </div>
                  </div>
                  {selectNum == index && <div className="select-line" style={{ height: underlineHeight, background: underlineColor }}></div>}
                </div>
              </React.Fragment>
            })}
          </div>

        </ScrollView>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/custom-component/timeline-custom-component/TimelineCustomComponent.jsx